import React, { useState, useEffect } from 'react';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './ImporterImage.module.scss';
import { checkMot } from '../../../ressources/functionJS/checkMot';

const ImporterImage = ({
  preconfigureImage,
  gererImageImporter,
  extensionAccepter,
}) => {
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState(null);

  useEffect(() => {
    if (preconfigureImage !== undefined) {
      setImage(preconfigureImage);
    }
  }, [preconfigureImage]);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFileName(file.name);
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
        gererImageImporter({ base64: e.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div className={[s.col_12, styles.margin].join(' ')}>
        <label htmlFor="avatar" />
        <input
          id="avatar"
          type="file"
          onChange={onImageChange}
          accept={extensionAccepter}
          className={styles.fileInput}
        />
      </div>
      
      {fileName && (
        <div className={styles.fileNameContainer}>
          <span className={styles.fileName}>
            {fileName}
            {image && (
              <img
                alt={checkMot('apercu_image')}
                src={image}
                className={styles.imageVisualisation}
              />
            )}
          </span>
        </div>
      )}
    </>
  );
};

export default ImporterImage;
